// removed by extract-text-webpack-plugin
module.exports = {"Card":"_3lJ8guhfTZry-g9Bh4EFf9","WarningContent":"_2qltWrLB2ws6YFRrGXYu31","WarningText":"_1FNR_v6we-slLYGk5x8Kgs","WarningConfirm":"_106IQAwDMFIcg9Ti4YOJsj","DuplicateList":"_2teckADUoUpoOiLI7-ZQUt","MatchReason":"_3lSct7DkfG8DQi6C2F6y_a","container-fluid":"_2ABr-hG4ba5kI6EFw-vOru","MainColumn":"_3bmk9qqHGWqnzsJgwUg6_p","SideColumn":"_3yZmbgkm48-zhAPK86OpSZ","StackOnMobile":"_1pI93UChVeIHJEWSrOcYgD"};


//////////////////
// WEBPACK FOOTER
// ./src/PagesOfUser/RegistryUpload/styles.module.css
// module id = 645
// module chunks = 0